import { useMemo } from 'react';
import { checkPermissions, hasAnyPermission } from 'react/utils/utils';

export const useRouteActionsMenuPermissions = () => {
  const canGoToRouteSummary = useMemo(
    () => hasAnyPermission(['ROUTE_MONITOR_SHOW', 'ROUTE_MONITOR_LIST']),
    []
  );

  const canEditRoute = useMemo(
    () => checkPermissions('ROUTE_UPDATE'),
    []
  );

  const canCloneRoute = useMemo(
    () => checkPermissions('ROUTE_MONITOR_CLONE_ROUTE'),
    []
  );

  const canStartRoute = useMemo(
    () => checkPermissions('ROUTE_MONITOR_START_ROUTE'),
    []
  );

  const canDepartFromOrigin = useMemo(
    () => checkPermissions('ROUTE_MONITOR_DEPART_ORIGIN'),
    []
  );

  const canArriveAtDestination = useMemo(
    () => checkPermissions('ROUTE_MONITOR_ARRIVE_AT_DESTINATION'),
    []
  );

  const canCompleteRoute = useMemo(
    () => checkPermissions('ROUTE_MONITOR_COMPLETE_ROUTE'),
    []
  );

  const canTransferStops = useMemo(
    () => checkPermissions('ROUTE_MONITOR_TRANSFER_STOPS'),
    []
  );

  const canShowOtherData = useMemo(
    () => checkPermissions('ROUTE_SUMMARY_OTHER_DATA'),
    []
  );

  return {
    canGoToRouteSummary,
    canEditRoute,
    canCloneRoute,
    canStartRoute,
    canDepartFromOrigin,
    canArriveAtDestination,
    canCompleteRoute,
    canTransferStops,
    canShowOtherData
  };
};
